// src/scripts/utils/utils.ts
var nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="20" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.19846 2.20215L7.03281 10.4L0.198459 18.5978C-0.103673 18.9607 -0.0540742 19.4988 0.30779 19.8015C0.669654 20.1042 1.20938 20.0551 1.51152 19.6927L8.8016 10.9474C8.9344 10.789 9 10.5944 9 10.4C9 10.2053 8.9344 10.0109 8.8016 9.8525L1.51152 1.10722C1.20939 0.744821 0.669922 0.695756 0.307791 0.99842C-0.0551391 1.30162 -0.104205 1.83868 0.19846 2.20215Z" /></svg></button>';
var prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="20" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80154 17.7979L1.96719 9.60004L8.80154 1.40223C9.10367 1.0393 9.05407 0.50117 8.69221 0.198505C8.33035 -0.104159 7.79062 -0.0550929 7.48848 0.307305L0.198397 9.05258C0.0655979 9.21098 -1.52707e-06 9.40564 -1.55863e-06 9.60004C-1.59024e-06 9.79471 0.0655978 9.98911 0.198397 10.1475L7.48848 18.8928C7.79061 19.2552 8.33008 19.3042 8.69221 19.0016C9.05514 18.6984 9.1042 18.1613 8.80154 17.7979Z"/></svg></button>`;

// src/scripts/templates/article.ts
$(() => {
  const gallery = document.querySelectorAll("[data-blog-content-image]");
  const scrollToTop = document.getElementById("scroll-button");
  const shareButton = document.getElementById("share-button");
  const options = {
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    prevArrow,
    nextArrow,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          prevArrow: false,
          nextArrow: false
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          prevArrow: false,
          nextArrow: false
        }
      }
    ]
  };
  const $articleCarousel = $("[data-article-carousel]");
  if ($articleCarousel) {
    $articleCarousel.slick(options);
  }
  const $shopCarousel = $("[data-shop-carousel]");
  if ($shopCarousel) {
    $shopCarousel.slick(options);
  }
  shareButton.addEventListener("click", () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      const text = shareButton.querySelector("span");
      text.innerText = "Copied to clipboard!";
      setTimeout(() => text.innerHTML = "Share article", 5e3);
    });
  });
  scrollToTop.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  gallery.forEach((element) => {
    const overlay = element.querySelector("[data-gallery-overlay]");
    element.addEventListener("mouseenter", () => {
      overlay.classList.add("active");
    });
    element.addEventListener("mouseleave", () => {
      overlay.classList.remove("active");
    });
  });
});
